import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function SharpnessIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="17"
        height="14"
        viewBox="0 0.5 16 13"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.8999 12.5L8.89995 0.500049C8.49995 -0.0999512 7.49995 -0.0999512 7.19995 0.500049L0.199947 12.5C-0.300053 13.2 0.199947 14 0.999947 14H14.9999C15.7999 14 16.2999 13.2 15.8999 12.5ZM7.99995 3.00005V12H2.69995L7.99995 3.00005Z" />
      </svg>
    </Icon>
  );
}
